import Config from '../config';

const COOKIE_NAME = Config.CompanyCookieName;
const MAX_AGE_SECONDS = Config.CompanyCookieMaxAgeDays * 24 * 60 * 60;

function securePart(): string {
  return window.location.protocol === 'https:' ? '; secure' : '';
}

function expireCompanyCookie(domain?: string): void {
  const domainPart = domain ? `; domain=${domain}` : '';
  document.cookie = `${COOKIE_NAME}=; path=/; max-age=0; samesite=lax${securePart()}${domainPart}`;
}

function clearCompanyCookieVariants(): void {
  const host = window.location.hostname;

  expireCompanyCookie();
  expireCompanyCookie(host);
}

/**
 * Persist the selected company ID as a browser cookie so that other
 * front-end apps on the same domain (e.g. main-frontend) can read it.
 *
 * The cookie is NOT httpOnly — company_id is not a secret (it is visible
 * in API URL paths) and must be readable by client-side JavaScript.
 */
export function setCompanyCookie(companyId: string): void {
  clearCompanyCookieVariants();
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(companyId)}; path=/; max-age=${MAX_AGE_SECONDS}; samesite=lax${securePart()}`;
}
